'use strict'

/**
 * Возвращает объект FormData, заполненный из объекта obj.
 * Размещает данные списков/массивов в FormData так, чтобы их понимал backend
 * @param obj
 * @returns {FormData}
 */
function obj_to_FormData(obj) {
	let data = new FormData()
	for (let key in obj) {
		const value = obj[key]
		if (value instanceof Array) {
			value.forEach(v => data.append(key, v))
		} else {
			data.append(key, value)
		}
	}

	return data
}

export {obj_to_FormData,}